import { Box } from '@mui/material';

import { InfoDialog, Button } from '@occc-app/design-system';

export type TestAndUpdateSFTPCredentialsStatusModalProps = {
  show: boolean;
  onCancel: () => void;
  onSave: () => void;
  isSftpTestSuccessful: boolean;
  isErrorHappened: boolean;
};

export const TestAndUpdateSFTPCredentialsStatusModal = ({
  show,
  onCancel,
  onSave,
  isSftpTestSuccessful,
  isErrorHappened,
}: TestAndUpdateSFTPCredentialsStatusModalProps) => {
  const title = isErrorHappened
    ? 'SFTP test failed. Please make sure all the SFTP details are correct before trying to save again.'
    : isSftpTestSuccessful
    ? 'SFTP test successful'
    : 'SFTP test in progress';

  const isInProgress = !isSftpTestSuccessful && !isErrorHappened;

  return (
    <InfoDialog
      dialogTitle={title}
      open={show}
      maxWidth='sm'
      hideCloseButton
      onClose={onCancel}
      dialogTitleProps={{ sx: { p: 4 } }}
      fullWidth
    >
      {isInProgress && (
        <Box p={2} display={'flex'} justifyContent={'flex-end'}>
          <Button variant='text' onClick={onCancel}>
            CANCEL
          </Button>
        </Box>
      )}
      {isSftpTestSuccessful && (
        <Box p={2} display={'flex'} justifyContent={'flex-end'} gap={2}>
          <Button variant='text' onClick={onCancel}>
            CANCEL
          </Button>
          <Button variant='contained' onClick={onSave}>
            SAVE
          </Button>
        </Box>
      )}
      {isErrorHappened && (
        <Box p={2} display={'flex'} justifyContent={'flex-end'}>
          <Button variant='contained' onClick={onCancel}>
            GO BACK
          </Button>
        </Box>
      )}
    </InfoDialog>
  );
};
